import SuperLinkDeepLinkQR from './qr_superlink.svg';
import GuestListDeepLinkQR from './qr_guestlist.svg';
import GuestListRsvpsDeepLinkQR from './qr_guestlist-rsvp.svg';

const QRCodes = { SuperLinkDeepLinkQR, GuestListDeepLinkQR, GuestListRsvpsDeepLinkQR };

export { SuperLinkDeepLinkQR, GuestListDeepLinkQR, GuestListRsvpsDeepLinkQR };

export default QRCodes;
